import { render, staticRenderFns } from "./ColField.vue?vue&type=template&id=779a3d39"
import script from "./ColField.vue?vue&type=script&lang=js"
export * from "./ColField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports